import { render } from "./message-bubble.vue?vue&type=template&id=2137e4cc&scoped=true&ts=true"
import script from "./message-bubble.vue?vue&type=script&lang=ts"
export * from "./message-bubble.vue?vue&type=script&lang=ts"

import "./message-bubble.vue?vue&type=style&index=0&id=2137e4cc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2137e4cc"]])

export default __exports__